export const brregUrl = 'https://data.brreg.no/enhetsregisteret/api';

const brregPaths = {
  enheter: `${brregUrl}/enheter`,
};

export const BRREG_ENHETER = `${brregPaths.enheter}`;
